import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faBullseye,
  faPenNib,
  faRocket,
  faGaugeHigh,
  faArrowsRotate,
} from "@fortawesome/free-solid-svg-icons";
import "./Process.css";

const Process = () => {
  const steps = [
    {
      title: "Listen & understand",
      description:
        "We start with your goals, audience, and current setup. What’s working, what isn’t, and what success looks like.",
      icon: faMagnifyingGlass,
      tip: "Context before concepts",
    },
    {
      title: "Agree on a plan",
      description:
        "We outline scope, deliverables, and timelines in a simple roadmap so everyone knows what happens when.",
      icon: faBullseye,
      tip: "No hidden steps",
    },
    {
      title: "Design the experience",
      description:
        "Structure, wireframes, and visual design come together into clear, conversion-ready layouts for review.",
      icon: faPenNib,
      tip: "Feedback-friendly drafts",
    },
    {
      title: "Build & integrate",
      description:
        "We develop the site or flows, connect required tools, and ensure everything works smoothly on modern devices.",
      icon: faRocket,
      tip: "Clean, maintainable code",
    },
    {
      title: "Test & launch",
      description:
        "We test forms, tracking, performance, and edge cases, then coordinate a smooth launch with minimal downtime.",
      icon: faGaugeHigh,
      tip: "Checklists over guesswork",
    },
    {
      title: "Support & improve",
      description:
        "After launch, we’re available to fix issues, refine content, and roll out improvements based on real usage.",
      icon: faArrowsRotate,
      tip: "Long-term partnership",
    },
  ];

  return (
    <section className="proc2" aria-label="Our process">
      <div className="proc2-wrap">
        {/* Header */}
        <header className="proc2-head">
          <p className="kicker">Process</p>
          <h2>A clear path from first call to launch.</h2>
          <p className="sub">
            No mystery, no chaos. Just a simple, collaborative workflow that keeps your project
            moving forward with visibility at every step.
          </p>
        </header>

        {/* Rail + grid */}
        <div className="proc2-rail" aria-hidden="true" />
        <ol className="proc2-grid">
          {steps.map((s, i) => (
            <li className="proc2-card" key={s.title}>
              <div className="badge">
                <span className="num">{String(i + 1).padStart(2, "0")}</span>
              </div>

              <div className="icon">
                <FontAwesomeIcon icon={s.icon} />
              </div>

              <h3>{s.title}</h3>
              <p>{s.description}</p>

              <div className="tip">
                <span className="dot" />
                <span>{s.tip}</span>
              </div>
            </li>
          ))}
        </ol>

        {/* Micro KPIs */}
        <div className="proc2-stats" role="list">
          <div className="stat" role="listitem">
            <div className="k">3–5 days</div>
            <div className="d">to first wireframes or concepts</div>
          </div>
          <div className="stat" role="listitem">
            <div className="k">2–6 weeks</div>
            <div className="d">typical project duration</div>
          </div>
          <div className="stat" role="listitem">
            <div className="k">95%+</div>
            <div className="d">projects launched on schedule</div>
          </div>
        </div>

        {/* CTA */}
        <div className="proc2-cta">
          <a className="btn btn-primary" href="/services" aria-label="See services">
            See services
          </a>
          <a className="btn btn-ghost" href="/contact" aria-label="Talk to us">
            Talk to us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
